import { type JSX } from 'react';

import { type GalleryBadgesTypes } from '../../types';
import { type FeatureLabelTooltipPlacement } from '../components/FeatureLabel';
import { HasVideoBadge } from '../components/HasVideoBadge';

export const badgesCollection = new Map<
  GalleryBadgesTypes,
  (props: { tooltipPlacement: FeatureLabelTooltipPlacement }) => JSX.Element
>([['hasVideo', (props): JSX.Element => <HasVideoBadge placement={props.tooltipPlacement} />]]);
